import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import AdminAuthorized from '../pages/AdminAuthorized';
import LandingPageComponent from '../pages/LandingPage';
import Login from '../pages/Login';
import OnboardingComponent from '../pages/Onboarding/Components';
import LoginWithOTPComponent from '../pages/Onboarding/Components/LoginWithOTP';
import StoreCreationComponent from '../pages/Onboarding/Components/StoreCreation';
import Register from '../pages/register';

const LoginRoutes = () => {
  const location = useLocation();
  return (
    <Switch>
      <Route exact path={'/admin-authorized'} component={AdminAuthorized} />
      <Route path="/register" component={Register} />
      <Route path="/sign-in" component={Login} />
      <Route path="/login" component={LandingPageComponent} />
      <Route path="/onboarding" component={OnboardingComponent} />
      <Route path="/signin" component={LoginWithOTPComponent} />
      <Route path="/store">
        {location?.state?.type === 'OTP-Login' ? (
          <StoreCreationComponent mobileNumber={location?.state?.mobileNumber} />
        ) : (
          <Redirect to={'/login'} />
        )}
      </Route>
      <Route path="/">
        <Redirect to="/login" />
      </Route>
    </Switch>
  );
};

export default React.memo(LoginRoutes);
